import { render } from "./App.vue?vue&type=template&id=3b1c0e0e"
const script = {}

import exportComponent from "/Users/jyrseige/work/replayAndVote/replayandvote/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__